import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { GET_STEP_SALE_CONFIG } from "../../api/apiRoutes";
import { get } from "../../api";
import { CLEAR_STEP_SALE_CONFIG, GET_STEP_SALE_CONFIGURATION } from "./saleStepConfigTypes";

export const getStepSaleConfig = createAsyncThunk(
  GET_STEP_SALE_CONFIGURATION,
  async (facilityIds: string) => await get(GET_STEP_SALE_CONFIG(facilityIds))
);

export const clearStepSaleConfig = createAction<void>(CLEAR_STEP_SALE_CONFIG);
